import { Component, Input, OnInit } from '@angular/core';
import { Page } from '@bloomreach/spa-sdk/';
import { CardContent, CardLinkClickEvent } from '@types';
import { CardsService } from '@services/cards.service';
import { MediaCardGroupContents } from '../media-card-group.interface';
import { Logger } from '@utils/logger';
import { WidenService } from '@services';

const logger = Logger.getLogger('ThumbnailsSectionComponent');
@Component({
  selector: 'ft-thumbnails-section',
  templateUrl: './thumbnails-section.component.html',
})
export class ThumbnailsSectionComponent implements OnInit {
  /**
   * Bloomreach page model
   */
  @Input() page: Page;

  /**
   * Page Section content
   */
  @Input() content: MediaCardGroupContents;

  /**
   * Cards Array
   */
  cards: Array<CardContent>;

  /**
   * margin bottom
   */
  spacingBottom: string;

  /**
   * Constructor
   * @param cardsService inject card service
   */
  constructor(
    private cardsService: CardsService,
    private widenService: WidenService
  ) {}

  /**
   * NgOnInit
   */
  ngOnInit() {
    if (this.content?.cardCompound) {
      this.cards = this.cardsService.formatCardURL(
        this.cardsService.formatCards(this.content?.cardCompound),
        this.page
      );
    }
    this.spacingBottom = this.content?.spacingBottom;
    if (this.cards) {
      this.setDynamicThumbnails(this.cards);
    }
  }

  /**
   * Set the download location of card service
   * @param event card click
   */
  public setDownloadLocation(event: CardLinkClickEvent) {
    this.cardsService.setDownloadLocation(event);
  }

  /**
   * Set thumbnails for pdfs
   * @param cards cards array of CardContent
   */
  public setDynamicThumbnails(cards: Array<CardContent>) {
    for (const card of cards) {
      logger.debug(card.link?.widenAssetCompound);
      if (card.eventParams?.embed_id) {
        // As this is a thumbnail component - let's get the document thumbnail from widen
        card.imgSrc = this.widenService.getThumbnailUrl(
          card.eventParams?.embed_id
        );
      }
    }
  }
}
